import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default function Universal() {

  const tlHome = gsap.timeline({
    delay: 0.5
  });
  tlHome.from(".hero-text .word, .hero-text .line", {
      yPercent: 101,
      opacity:0,
      stagger: 0.1,
      // duration: 1,
  });


  try {
    gsap.utils.toArray('.reveal-line').forEach((el, i) => {
      const line = el.querySelectorAll('.line');
      const tl_universal = gsap.timeline({
        scrollTrigger: {
          trigger: el
        }
      });

      tl_universal.from(line, {
        yPercent: 101,
        opacity:0,
        stagger: 0.1,
      });
    });

    gsap.utils.toArray('.reveal-word').forEach((el, i) => {
      const word = el.querySelectorAll('.word');
      const tl_universal = gsap.timeline({
        scrollTrigger: {
          trigger: el
        }
      });

      tl_universal.from(word, {
        yPercent: 101,
        stagger: 0.1,
        opacity:0,
      });
    });

    const hrlines = gsap.utils.toArray('.reveal-hr');
    hrlines.forEach((hrline, i) => {
      const anim = gsap.fromTo(hrline, {
       width:"0",
      },{
        width:"100%",
        duration:1,
      });

      ScrollTrigger.create({
        trigger: hrline,
        animation: anim,
        toggleActions: 'play none none none',
        once: true,
      });
    });
    

    const imgscales = gsap.utils.toArray('.transition-img-scale');
    imgscales.forEach((imgscale, i) => {
      const anim = gsap.fromTo(imgscale, {
       width:"70%",
      },{
        width:"100%",
      });

      ScrollTrigger.create({
        trigger: imgscale,
        animation: anim,
        start:"top 20%",
        end: "50% top",
        toggleActions:"play none none reverse",
        scrub: true,
      });
    });


  } catch (error) {}
}